import React, { useState } from 'react';
import { Icon } from '@/components';
import { i18n } from '@/utils';
import { SockBottomImage } from './new-sock';
import styles from './style.less';

interface ChooseColorProps {
  /** 颜色 */
  colors: SockBottomImage[];
  /** 已选择颜色 */
  selectedColor: SockBottomImage;
  /** 关闭回调 */
  onClose: () => void;
  /** 确认回调 */
  onConfirm: (color: SockBottomImage) => void;
}

const ChooseColor: React.FC<ChooseColorProps> = ({ colors, selectedColor, onClose, onConfirm }) => {

  /** 选择的颜色 */
  const [color, setColor] = useState<SockBottomImage>(selectedColor);

  return (
    <div className={styles.colorDrawer}>
      <div className={styles.header}>
        {i18n.format('modules.new.sock.choose.color')}
      </div>
      <div className={styles.content}>
        <div className={styles.options}>
          {colors.map(item => {
            const backgroundImage = item.variantImage || item.image;
            const isImage = backgroundImage.includes('http');
            return (
              <div
                key={item.id}
                className={styles.option}
                style={{
                  backgroundImage: isImage ? `url(${backgroundImage})` : undefined,
                  backgroundColor: !isImage ? backgroundImage : undefined,
                }}
                onClick={() => setColor(item)}
              >
                {color.id === item.id &&
                  <div className={styles.tick}>
                    <Icon type='tick-circle' size={24} color='#ff533a' />
                  </div>
                }
              </div>
            )
          })}
        </div>
      </div>
      <div className={styles.footer}>
        <div className={styles.cancel} onClick={onClose}>
          {i18n.format('modules.global.cancel')}
        </div>
        <div className={styles.confirm} onClick={() => onConfirm(color)}>
          {i18n.format('modules.new.sock.confirm')}
        </div>
      </div>
    </div>
  );
}

export default ChooseColor;
